module.exports = __webpack_public_path__ + "static/media/image-casa.b2eac60e.png";